import React from 'react';
import Particle from '../components/Particle';
import SliderMainParticle from '../components/SliderMainParticle';
import FeatureBox from '../components/FeatureBox';
import Footer from '../components/footer';
import { createGlobalStyle } from 'styled-components';
import Verticaltimeline from '../verticaltimeline';
import ColumnZeroThree from '../components/ColumnZeroThree';

const GlobalStyles = createGlobalStyle`
  header#myHeader .logo .d-block{
    display: none !important;
  }
  header#myHeader .logo .d-none{
    display: block !important;
  }
  .navbar .mainside a{
    background: #8364e2;
    &:hover{
      box-shadow: 2px 2px 20px 0px #8364e2;
    }
  }
  .item-dropdown{
    .dropdown{
      a{
        &:hover{
          background: #8364e2;
        }
      }
    }
  }
  .btn-main{
    background: #8264e2;
    &:hover{
      box-shadow: 2px 2px 20px 0px #8264e2;
    }
  }

  .btn-main1{
    background: #008000;
    &:hover{
      box-shadow: 2px 2px 20px 0px #008000;
    }
  }
  .icon{
    margin-left : 10px;
  }
  .icon1{
    margin: 0 auto;
    text-align : center;

  }
  style {
    text-decoration : underline;
  }
  p.lead{
    color: #fff;
  }
  .navbar .navbar-item .lines{
    border-bottom: 2px solid #8364e2;
  }
  .jumbotron.no-bg{
    height: 80%;
    overflow: hidden;
    background-repeat: repeat;
    background-size: cover;
    background-position: bottom;
    background-repeat: no-repeat;
  }
  #tsparticles{
    top: 0;
  }
  .text-uppercase.color{
    color: #008000;
  }
  .de_count h3 {
    font-size: 36px;
    margin-bottom: 0px;
  }
  .de_count h5{
    font-size: 14px;
    font-weight: 500;
  }
  h2 {
    font-size: 40px;
    text-align : center;
    text-decoration : underline red;
    text-underline-position: under;
  }
  .box-url{
    text-align: center;
    h4{
      font-size: 16px;
    }
  }
  .de_countdown{
    border: solid 2px #8364e2;
  }
  .author_list_pp, .author_list_pp i, 
  .nft_coll_pp i, .feature-box.style-3 i, 
  footer.footer-light #form_subscribe #btn-subscribe i, 
  #scroll-to-top div{
    background: #8364e2;
  }
  footer.footer-light .subfooter .social-icons span i{
    background: #403f83;
  }
  .author_list_pp:hover img{
    box-shadow: 0px 0px 0px 2px #8364e2;
  }
  .nft__item_action span{
    color: #8364e2;
  }
  .feature-box.style-3 i.wm{
    color: rgba(131,100,226, .1);
  }
  @media only screen and (max-width: 1199px) {
    .navbar{
      
    }
    .navbar .menu-line, .navbar .menu-line1, .navbar .menu-line2{
      background: #fff;
    }
    .item-dropdown .dropdown a{
      color: #fff !important;
    }
  }
`;


const homeone = () => (
    <div>
        <GlobalStyles />
        <section className="jumbotron no-bg" style={{ backgroundImage: `url(${'./img/background/15.jpg'})` }}>
            <Particle />
            <SliderMainParticle />
        </section>

        <section className='container no-bottom'>
            <div className="row">

                <div className="col-lg-4 col-sm-4 col-6 mb30">
                    <a href="https://www.terra.money/" target="_blank" style={{ textDecoration: 'none' }}>
                        <span className="box-url">
                            <img src="./img/wallet/terra.png" alt="" className="mb20" />
                            <h4>Terra</h4>
                        </span>
                    </a>
                </div>

                <div className="col-lg-4 col-sm-4 col-6 mb30">
                    <span className="box-url">
                        <a href="https://www.angelprotocol.io/" target="_blank" style={{ textDecoration: 'none' }}>
                            <img src="./img/wallet/angelprotocol.png" alt="" className="mb20" />
                            <h4>AngelProtocol</h4>
                        </a>
                    </span>
                </div>
                <div className="col-lg-4 col-sm-4 col-6 mb30">
                    <span className="box-url">
                        <img src="./img/wallet/mtc.png" alt="" className="mb20" />
                        <h4>MTC</h4>
                    </span>
                </div>
            </div>
        </section>

        <section className='container no-top'>
            <div className='row'>
                <div className="spacer-double"></div>
                <div className='col-lg-12 mb-3'>
                    <h2 className='style'>About Merry Terra Christmas</h2>
                </div>
                <FeatureBox />
            </div>
        </section>

        <section className='container no-top'>

            <div className="spacer-double"></div>
            <div className='col-lg-12 mb-3'>
                <h2>Roadmap</h2>
            </div>
            <Verticaltimeline />

        </section>

        <section className='container no-top'>

            <div className="spacer-double"></div>
            <div className='col-lg-12 mb-3'>
                <h2>Meet the Team</h2>
            </div>
            <ColumnZeroThree />
        </section>

        <Footer />

    </div>
);
export default homeone;